import React from "react";
import './coursesoffstyle.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import accountsplan from '../../imagesHome/accountsplan.png';
import SocialLoginRegistrer from './SocialLoginRegistrer';
import Registrercourse from './Registrercourse';

const PageGameAccoutPlanOff = () => {
  return (
    <div className="general-frame-bc-cf">
    <div className="general-frame-game-green">
      {/* 🔹 Breadcrumb */}
     

      <div className="game-hero-section-green">
        {/* 🔹 Stânga - Titlu și descriere */}

        <div className="breadcrumb-game-green">
          <span>Jocuri</span>
          <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-game-green-icon" />
          <span className="current">Planul de conturi</span>
        </div>
        <div className="game-hero-content-green">

       <div className="game-hero-left-green">
  <img src={accountsplan} alt="planul de conturi" />
  <h1>Planul de conturi</h1>
  <p>
    Memoreaza codurile conturilor din planul general contabil intr-un mod
    rapid si distractiv! Acest joc te ajuta sa asociezi instant fiecare cont
    cu codul sau numeric.
  </p>
  <p>
    Vei exersa cele mai importante conturi: 401, 411, 5121, 512, 707, 607
    si multe altele. Perfect pentru a te pregati pentru examene sau pentru
    munca zilnica in contabilitate.
  </p>
  <p>
    Cu cat joci mai mult, cu atat mai rapid vei recunoaste codurile
    conturilor - o abilitate esentiala pentru orice contabil!
  </p>
</div>


        {/* 🔹 Dreapta - card/formular */}
        <div className="game-hero-right-green">
          <div className="game-card-green">
            <h2>Inregistreaza-te gratuit pe ContaLearn</h2>
            <p>Acceseaza jocul si invata planul de conturi pe repede inainte!</p>
          

               <div><Registrercourse /></div>
               <div className="sau-game-green">sau</div>
               <div><SocialLoginRegistrer /></div>
          </div>
        </div>
        </div>
      </div>

    

    </div>
      
      {/* 🔹 Secțiunea 2: Ce vei învăța */}
      <div className="game-learn-section-green">
        <div className="game-learn-container-green">
          <h2 className="game-section-title-green">Ce vei exersa in acest joc</h2>
          <p className="game-section-subtitle-green">
            Invata sa asociezi rapid conturile cu codurile lor din planul general contabil romanesc.
          </p>

          <div className="game-cards-grid-green">
            {/* Exemplu 1 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">💰</span>
              <h3 className="game-card-title-green">Conturi de trezorerie</h3>
              <p className="game-card-desc-green">
                Memoreaza codurile pentru Casa (5311), Banca (5121), Credite bancare (5191) si altele.
              </p>
            </div>

            {/* Exemplu 2 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">🏢</span>
              <h3 className="game-card-title-green">Conturi de clienti si furnizori</h3>
              <p className="game-card-desc-green">
                Exerseaza codurile: Clienti (411), Furnizori (401), Creante/Datorii diverse (4118/462).
              </p>
            </div>

            {/* Exemplu 3 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">📦</span>
              <h3 className="game-card-title-green">Conturi de stocuri</h3>
              <p className="game-card-desc-green">
                Invata codurile pentru Marfuri (371), Materii prime (301), Produse finite (345).
              </p>
            </div>

            {/* Exemplu 4 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">📊</span>
              <h3 className="game-card-title-green">Conturi de venituri</h3>
              <p className="game-card-desc-green">
                Memoreaza: Venituri din vanzari (707), Venituri din productie (701), Venituri financiare (766).
              </p>
            </div>

            {/* Exemplu 5 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">💳</span>
              <h3 className="game-card-title-green">Conturi de cheltuieli</h3>
              <p className="game-card-desc-green">
                Exerseaza: Cheltuieli cu marfurile (607), Salarii (641), Utilitati (628).
              </p>
            </div>

            {/* Exemplu 6 */}
            <div className="game-feature-card-green">
              <span className="game-card-icon-green">🔢</span>
              <h3 className="game-card-title-green">Conturi de imobilizari</h3>
              <p className="game-card-desc-green">
                Invata codurile pentru: Terenuri (211), Cladiri (212), Echipamente (2131), Software (205).
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 3: Cum funcționează jocul */}
      <div className="game-how-section-green">
        <div className="game-how-container-green">
          <h2 className="game-section-title-green">Cum functioneaza jocul</h2>
          
          <div className="game-steps-grid-green">
            <div className="game-step-item-green">
              <div className="game-step-icon-green">📋</div>
              <div className="game-step-number-green">1</div>
              <div className="game-step-label-green">Vezi un cont</div>
            </div>

            <div className="game-step-item-green">
              <div className="game-step-icon-green">🤔</div>
              <div className="game-step-number-green">2</div>
              <div className="game-step-label-green">Gandesti la cod</div>
            </div>

            <div className="game-step-item-green">
              <div className="game-step-icon-green">✍️</div>
              <div className="game-step-number-green">3</div>
              <div className="game-step-label-green">Alegi codul corect</div>
            </div>

            <div className="game-step-item-green">
              <div className="game-step-icon-green">⚡</div>
              <div className="game-step-number-green">4</div>
              <div className="game-step-label-green">Memorizezi rapid</div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 4: Beneficii */}
      <div className="game-benefits-section-green">
        <div className="game-benefits-container-green">
          <h2 className="game-section-title-green">De ce sa joci acest joc</h2>
          
          <div className="game-benefits-list-green">
            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Memorare rapida</h4>
                <p>Inveti codurile conturilor mult mai repede decat din manuale</p>
              </div>
            </div>

            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Esential pentru examene</h4>
                <p>Cunoasterea planului de conturi este obligatorie la majoritatea testelor</p>
              </div>
            </div>

            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Viteza in munca</h4>
                <p>Vei lucra mult mai rapid cand stii codurile pe dinafara</p>
              </div>
            </div>

            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Recapitulare eficienta</h4>
                <p>Perfect pentru refresh-ul cunostintelor inainte de certificari</p>
              </div>
            </div>

            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Practică si aplicabilitate</h4>
                <p>Folosesti aceste coduri zilnic in orice soft de contabilitate</p>
              </div>
            </div>

            <div className="game-benefit-item-green">
              <div className="game-benefit-check-green">✓</div>
              <div>
                <h4>Confidence boost</h4>
                <p>Stii exact ce cont sa folosesti in orice situatie</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 🔹 Secțiunea 5: Final CTA */}
      <div className="game-final-cta-green">
        <div className="game-cta-content-green">
          <h2>Gata sa inveti?</h2>
          <p>Inregistreaza-te gratuit si stapaneste planul de conturi ca un profesionist!</p>
          <div className="game-cta-buttons-green">
            <Registrercourse />
            <div className="sau-game-cta-green">sau</div>
            <SocialLoginRegistrer />
          </div>
        </div>
      </div>

    </div>
  );
};

export default PageGameAccoutPlanOff;
